/**
 * Colunas que NÃO estão na cadeia de migrações do `drizzle/` e são adicionadas no boot,
 * de forma idempotente, por `repairLegacySchema` (db/client). Existem por razões
 * históricas: bases antigas que perderam o passo de migração.
 *
 * CONSEQUÊNCIA IMPORTANTE: rodar só os `drizzle/*.sql` NÃO produz o schema real do
 * aparelho. Quem monta um banco de teste (test/dbHarness) tem que aplicar isto também,
 * senão o teste quebra em `no such column` numa coluna que existe em produção. Por isso
 * o mapa vive num módulo próprio em vez de dentro do db/client — o harness não pode
 * importar o client (ele abre o op-sqlite real).
 */

export const LEGACY_SCHEMA_REPAIRS = {
    accounts: [
        { name: 'is_excluded_from_totals', sql: 'ALTER TABLE accounts ADD COLUMN is_excluded_from_totals integer DEFAULT 0 NOT NULL' },
    ],
    transactions: [
        { name: 'is_recurring', sql: 'ALTER TABLE transactions ADD COLUMN is_recurring integer DEFAULT 0 NOT NULL' },
        { name: 'recurring_id', sql: 'ALTER TABLE transactions ADD COLUMN recurring_id text' },
        { name: 'installment_id', sql: 'ALTER TABLE transactions ADD COLUMN installment_id text' },
        { name: 'installment_number', sql: 'ALTER TABLE transactions ADD COLUMN installment_number integer' },
        { name: 'installment_total', sql: 'ALTER TABLE transactions ADD COLUMN installment_total integer' },
        { name: 'financing_id', sql: 'ALTER TABLE transactions ADD COLUMN financing_id text REFERENCES financings(id)' },
        { name: 'financing_entry_type', sql: 'ALTER TABLE transactions ADD COLUMN financing_entry_type text' },
        { name: 'financing_installment_number', sql: 'ALTER TABLE transactions ADD COLUMN financing_installment_number integer' },
        { name: 'adjustment_type', sql: 'ALTER TABLE transactions ADD COLUMN adjustment_type text' },
        { name: 'is_confirmed', sql: 'ALTER TABLE transactions ADD COLUMN is_confirmed integer DEFAULT 1 NOT NULL' },
        { name: 'is_hidden_from_subs', sql: 'ALTER TABLE transactions ADD COLUMN is_hidden_from_subs integer DEFAULT 0 NOT NULL' },
        { name: 'deleted_at', sql: 'ALTER TABLE transactions ADD COLUMN deleted_at text' },
    ],
    recurring_transactions: [
        { name: 'is_hidden_from_subs', sql: 'ALTER TABLE recurring_transactions ADD COLUMN is_hidden_from_subs integer DEFAULT 0 NOT NULL' },
        { name: 'advance_reminder_enabled', sql: 'ALTER TABLE recurring_transactions ADD COLUMN advance_reminder_enabled integer DEFAULT 0 NOT NULL' },
        { name: 'deleted_at', sql: 'ALTER TABLE recurring_transactions ADD COLUMN deleted_at text' },
    ],
    auto_categorization_rules: [
        { name: 'deleted_at', sql: 'ALTER TABLE auto_categorization_rules ADD COLUMN deleted_at text' },
    ],
} as const;

export type LegacyRepairTable = keyof typeof LEGACY_SCHEMA_REPAIRS;
